import {APPLIED_JOBS_VENDOR_FAIL,APPLIED_JOBS_VENDOR_SUCCESS,APPLIED_JOBS_VENDOR_REQUEST} from "../constants/AuthConstant"
const axios = require("axios");

export const AppliedJobViewAction = (data) => {
    console.log('data------999 ', data)
    return function (dispatch) {
      dispatch({
        type: APPLIED_JOBS_VENDOR_REQUEST,
        payload: true,
      });
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/get_apply_job_list_by_vendorId?vendorId=${data.id}&pageNumber=${data?.pageNumber ?? 0}&pageSize=10&search=${data?.search}&designation=${data?.designationSendapi || []}`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      };
      axios(OPTION)
        .then((res) => {
            console.log(res.data,"hello")
          dispatch(loadAllDetailsPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: APPLIED_JOBS_VENDOR_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
        });
    };
  };

  export const loadAllDetailsPre = (data) => {
    return {
      type: APPLIED_JOBS_VENDOR_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };